import mapValues from "./mapValues";

const handleLoadSelectOptions = async (e, functionGetter, additionalParams, label, valueKey) => {
    const getData = await functionGetter({ params: { name: e, perPage: 30, page: 1, ...additionalParams } }, { useCache: false });
    return mapValues(getData?.data?.data, label, valueKey);
}

export default handleLoadSelectOptions;